import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Provider as AssetViewerContextProvider } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import AssetViewer from './AssetViewer';
import useAssetViewerQueryParams from 'screens/AssetViewerUI/hooks/useAssetViewerQueryParams';
function SimpleAssetViewerFromQuery() {
  var _useAssetViewerQueryP = useAssetViewerQueryParams('assetId'),
    _useAssetViewerQueryP2 = _slicedToArray(_useAssetViewerQueryP, 2),
    params = _useAssetViewerQueryP2[0],
    removeParams = _useAssetViewerQueryP2[1];
  var assetId = params === null || params === void 0 ? void 0 : params.assetId;
  if (!assetId) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AssetViewerContextProvider, {
    assetId: assetId
  }, /*#__PURE__*/React.createElement(AssetViewer, {
    onClose: removeParams
  }));
}
export default SimpleAssetViewerFromQuery;